// Helpers/QuestionDB.js

var data = [
    {
       id:1,
       type: "user_profil",
       q_content:"Comment préférez-vous manger une salade de fruits ?",
       answers_nb: 3,
       answers:[
            {
                id:11,
                a_type : "check-box",
                a_content: "Sans sucre",
                score: 0
            },
            {
                id:12,
                a_type : "check-box",
                a_content: "Peu sucrée",
                score: 1
            },
            {
                id:13,
                a_type : "check-box",
                a_content: "Sucrée",
                score: 2
            }
       ]
    },
    {
       id:2,
       type: "user_profil",
       q_content:"Comment buvez-vous votre café ?",
       answers_nb: 4,
       answers:[
            {
                id:21,
                a_type : "check-box",
                a_content: "Je ne bois pas de café",
                score: 0
            },
            {
                id:22,
                a_type : "check-box",
                a_content: "Sucré",
                score: 1
            },
            {
                id:23,
                a_type : "check-box",
                a_content: "Au lait",
                score: 1
            },
            {
                id:24,
                a_type : "check-box",
                a_content: "Sans sucre",
                score: 2
            },
       ]
    },
    {
        id:3,
        type: "user_profil",
        q_content:"Vous laissez infuser votre thé ?",
        answers_nb: 4,
        answers:[
            {
                id:31,
                a_type : "check-box",
                a_content: "Je ne bois pas de thé",
                score: 0
            },
            {
                id:32,
                a_type : "check-box",
                a_content: "Légèrement",
                score: 0
            },
            {
                id:33,
                a_type : "check-box",
                a_content: "Normalement",
                score: 1
            },
            {
                id:34,
                a_type : "check-box",
                a_content: "Longtemps",
                score: 2
            }
       ]
     },
    {
        id:4,
        type: "user_profil",
        q_content:"Êtes-vous plutôt ?",
        answers_nb: 3,
        answers:[
            {
                id:41,
                a_type : "check-box",
                a_content: "Salé",
                score: 0
            },
            {
                id:42,
                a_type : "check-box",
                a_content: "Sucré",
                score: 1
            },
            {
                id:43,
                a_type : "check-box",
                a_content: "Les deux",
                score: 2
            }
       ]
    }

]

export default data
 
 